import React from "react";
import classes from "./description.module.css";

const Description = ({ description, className, style = {} }) => {
  return <p className={classes.description}>{description}</p>;
};

export default Description;
